import axios from 'axios';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useRequest = (hookProps: any) => {
  const [pending, setPending] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const request = async (props: any) => {
    setPending(true);

    try {
      const response = await axios({
        baseURL: hookProps.local ? '' : process.env.NEXT_PUBLIC_API_URL,
        url: props?.url || hookProps.url,
        params: props?.queryParams || hookProps.queryParams,
        method: hookProps.method,
        data: props?.body || hookProps.body,
        auth: process.env.NEXT_PUBLIC_ENV_TYPE === 'dev' ? {
          username: 'webitlabs',
          password: 'webitlabs'
        } : {
          username: '',
          password: ''
        },
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem('token')}`,
          'Content-Type':
            hookProps.headers?.['Content-Type'] || 'application/json',
        },
      });
      hookProps.onSuccess &&
        hookProps.onSuccess(response.data ? response.data : response);
      hookProps.onSuccessMessage &&
        enqueueSnackbar(hookProps.onSuccessMessage, {
          variant: 'success',
        });
    } catch (error: any) {
      hookProps.onError && hookProps.onError(error, error.response?.data);

      !hookProps.hideErrorMessage &&
        enqueueSnackbar(error.response?.data?.message || error.message, {
          variant: 'error',
        });

      setPending(false);
      return false;
    }

    setPending(false);
    return true;
  };

  return { request, pending };
};

export default useRequest;
